/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  user: {},
  activeUsers: [],
  loading: true,
  serverError: '',
};

export const staffLeadNone = {
  id: '0',
  name: 'None',
  notAssigned: false,
};

export const actions = {
  setUser({ commit }, user) {
    return commit('SET_USER', user);
  },
  async fetchActiveUsers({ commit, state }) {
    // only fetch if not already loaded
    if (state.activeUsers.length === 0) {
      commit('SET_LOADING', true);
      await api.get('users')
        .then((response) => {
          const activeUsers = response.data;
          // put 'Non-VOF' and '' at the end of the list
          // add 'None' as an option
          if (activeUsers.filter(u => u.id === '0').length === 0) {
            activeUsers.push(staffLeadNone);
          }
          commit('SET_ACTIVE_USERS', activeUsers);
          commit('SET_SERVER_ERROR', '');
          commit('SET_LOADING', false);
        })
        .catch((error) => {
          commit('SET_SERVER_ERROR', error.response.data);
          commit('SET_LOADING', false);
        });
    }
  },
};

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_ACTIVE_USERS(state, entities) {
    state.activeUsers = entities;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SERVER_ERROR(state, serverError) {
    state.serverError = serverError;
  },
};

export const getters = {
  getCurrentUser: () => state.user,
  isCurrentUserViewOnly: () => {
    let roles = '';
    if (state.user && state.user.idToken) {
      roles = state.user.idToken.roles.join(', ');
    }
    return roles.includes('viewonly');
  },
  getUserName: state => (id) => {
    if (id) {
      const userFound = state.activeUsers.find(u => u.id === id);
      return userFound ? userFound.name : 'User does not exist or is not active anymore.';
    }
    return 'Cannot get a user name without its id.';
  },
  isCurrentUserAdmin: () => {
    let roles = '';
    if (state.user && state.user.idToken) {
      roles = state.user.idToken.roles.join(', ');
    }
    return roles.includes('Admin');
  },
  getCurrentUserFromActiveUsers: (state) => {
    const filteredUsers = state.activeUsers.filter(u => u.id === state.user.idToken.oid);
    if (filteredUsers.length > 0) {
      return filteredUsers[0];
    }
    return null;
  },
};
